/**
 * Fractional indexing utilities for maintaining ordered lists without
 * renumbering all items when inserting or reordering.
 *
 * Each item has a floating-point `position`. To insert between two items,
 * use between(a.position, b.position). To append, use atEnd(maxPosition).
 */

export function between(a: number, b: number): number {
  if (b <= a) {
    // If b is not greater than a, just step forward from a
    return a + 1.0
  }
  const mid = (a + b) / 2
  // Warn when the gap becomes too small — caller should rebalance by
  // reassigning integer positions to all items in the list
  if (b - a < 1e-9) {
    console.warn('fracidx: position gap too small, rebalance needed')
  }
  return mid
}

export function atEnd(maxPos: number): number {
  return maxPos + 1.0
}

export function atStart(minPos: number): number {
  return minPos - 1.0
}

/**
 * Rebalance a list of items by assigning evenly-spaced integer positions.
 * Returns a new array with updated positions (does not mutate input).
 */
export function rebalance<T extends { position: number }>(items: T[]): T[] {
  return items.map((item, i) => ({ ...item, position: i + 1 }))
}
